import React from 'react'

const BADGE_CLASS: Record<string, string> = {
  RE: 'bg-gray-100 text-gray-800',
  FE: 'bg-indigo-100 text-indigo-800',
  FS: 'bg-sky-100 text-sky-800',
  FR: 'bg-violet-100 text-violet-800',
  NC: 'bg-amber-100 text-amber-800'
}

interface OfimaTipoBadgeProps {
  tipo: string
}

const OfimaTipoBadge: React.FC<OfimaTipoBadgeProps> = ({ tipo }) => {
  const normalized = tipo.trim().toUpperCase()
  const className = BADGE_CLASS[normalized] ?? 'bg-gray-100 text-gray-700'

  return (
    <span className={`inline-flex rounded-md px-2 py-0.5 text-xs font-semibold tracking-wide ${className}`}>
      {normalized || tipo}
    </span>
  )
}

export default OfimaTipoBadge
